import { raf } from './index';

function cubicBezier(x1, y1, x2, y2, epsilon) {
  var curveX = function curveX(t) {
    var v = 1 - t;
    return 3 * v * v * t * x1 + 3 * v * t * t * x2 + t * t * t;
  };

  var curveY = function curveY(t) {
    var v = 1 - t;
    return 3 * v * v * t * y1 + 3 * v * t * t * y2 + t * t * t;
  };

  var derivativeCurveX = function derivativeCurveX(t) {
    var v = 1 - t;
    return 3 * (2 * (t - 1) * t + v * v) * x1 + 3 * (-t * t * t + 2 * v * t) * x2;
  };

  return function (t) {
    var x = t;
    var t0;
    var t1;
    var t2;
    var x2;
    var d2;
    var i; // First try a few iterations of Newton's method -- normally very fast.

    for (t2 = x, i = 0; i < 8; i++) {
      x2 = curveX(t2) - x;
      if (Math.abs(x2) < epsilon) return curveY(t2);
      d2 = derivativeCurveX(t2);
      if (Math.abs(d2) < 1e-6) break;
      t2 -= x2 / d2;
    }

    t0 = 0;
    t1 = 1;
    t2 = x;
    if (t2 < t0) return curveY(t0);
    if (t2 > t1) return curveY(t1); // Fallback to the bisection method for reliability.

    while (t0 < t1) {
      x2 = curveX(t2);
      if (Math.abs(x2 - x) < epsilon) return curveY(t2);
      if (x > x2) t0 = t2;else t1 = t2;
      t2 = (t1 - t0) * 0.5 + t0;
    } // Failure


    return curveY(t2);
  };
}

;
export default (function (options) {
  var bezier = options.bezier,
      bezierList = options.bezierList;
  if (!bezierList && !bezier) return;
  var startTime = Date.now();
  var epsilon = 1000 / 60 / (options === null || options === void 0 ? void 0 : options.duration) / 4;
  var bezierStack = bezierList || [bezier];
  var isArray = !!bezierList;
  var getBezierProgressList = bezierStack.map(function (item) {
    return cubicBezier(item[0], item[1], item[2], item[3], // 精度
    epsilon);
  });

  function update() {
    var currentTime = Date.now() - startTime;
    var progress = Math.min(currentTime / (options === null || options === void 0 ? void 0 : options.duration), 1);

    if (progress < 1) {
      var progressList = getBezierProgressList.map(function (getBezierProgress) {
        return getBezierProgress(progress);
      });

      if (options !== null && options !== void 0 && options.callback) {
        var nextStatus = options === null || options === void 0 ? void 0 : options.callback(isArray ? progressList : progressList[0]); // callback返回false可以阻断后续监听

        if (nextStatus !== false) {
          raf(update);
        }
      }
    } else {
      (options === null || options === void 0 ? void 0 : options.onFinish) && (options === null || options === void 0 ? void 0 : options.onFinish());
    }
  }

  raf(update);
});